import React from "react";
import QuoteSection from "../components/quote";

const QuotePage = () => {
  return <QuoteSection />;
};

export default QuotePage;
